import BaseWorker from "./baseworker"

class CpWorker extends BaseWorker

{
    constructor(id)
    {
        super("cpworker", id);
    }

    setLanguage(language)
    {
    
        if (language == "fr")
            this.title = "Changements Plan"
        else
            this.title = "Shot scanning"
        super.setLanguage(language);
    }
    setVideo(datas)
    {
        super.setVideo(datas);
        this.status = datas.vixcp;
        this.error = datas.vierrorlibcp;
        this.pc = datas.vixcppc;
        this.pid = datas.vixcppid;

    }
    




getSize ()
{
    return {width:300, height:110};
}

draw (canvas, ctx)
{
    super.draw(canvas, ctx);
    if (this.status === -2) return;
    ctx.textBaseline = "top";
    ctx.font = "12px Arial";
    ctx.fillStyle="white";
    ctx.save()
    ctx.beginPath();
    ctx.rect(
        this.posX + 10,
        this.posY,
        this.getSize().width  - 20,
        this.getSize().height,
    )
    ctx.clip();
    ctx.fillText(this.video.vixcpfile + ".json", this.posX  + 10, 
        this.posY + 40);
    ctx.fillText(this.video.vixcpfile + ".jpegs", this.posX  + 10, 
            this.posY + 60);
        ctx.restore()

}    
}


export default CpWorker
